import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "sonner";
import "./App.css";

import Layout from "./components/Layout";
import HomePage from "./pages/HomePage";
import JCStoryPage from "./pages/JCStoryPage";
import FounderPage from "./pages/FounderPage";
import LegislationPage from "./pages/LegislationPage";
import ResourcesPage from "./pages/ResourcesPage";
import GetInvolvedPage from "./pages/GetInvolvedPage";
import DonatePage from "./pages/DonatePage";
import FAQPage from "./pages/FAQPage";
import ContactPage from "./pages/ContactPage";
import { PressPage, BlogPage } from "./pages/ComingSoonPages";
import PrivacyPolicyPage from "./pages/PrivacyPolicyPage";
import TermsOfUsePage from "./pages/TermsOfUsePage";
import NotFoundPage from "./pages/NotFoundPage";
import { PetitionProvider } from "./lib/petitionContext";

function App() {
    return (
        <HelmetProvider>
            <div className="App">
                <BrowserRouter>
                    <PetitionProvider>
                        <Routes>
                            <Route element={<Layout />}>
                                <Route path="/" element={<HomePage />} />
                                <Route path="/our-story" element={<JCStoryPage />} />
                                <Route path="/founder" element={<FounderPage />} />
                                <Route path="/legislation" element={<LegislationPage />} />
                                <Route path="/resources" element={<ResourcesPage />} />
                                <Route path="/get-involved" element={<GetInvolvedPage />} />
                                <Route path="/donate" element={<DonatePage />} />
                                <Route path="/faq" element={<FAQPage />} />
                                <Route path="/contact" element={<ContactPage />} />
                                <Route path="/press" element={<PressPage />} />
                                <Route path="/blog" element={<BlogPage />} />
                                <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
                                <Route path="/terms-of-use" element={<TermsOfUsePage />} />
                                <Route path="*" element={<NotFoundPage />} />
                            </Route>
                        </Routes>
                    </PetitionProvider>
                </BrowserRouter>
                <Toaster position="top-right" richColors closeButton />
            </div>
        </HelmetProvider>
    );
}

export default App;
